import React, { useContext, useState } from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import moment from "moment";
import { COLORS } from "@app/constants";
import { View } from "@/styles/reactnative";
import { data } from "../chartData";
import ChartTooltip from "../ChartTooltip";
import { ThemeContext } from "@/theme/ThemeProvider";

const CryptoTradingGraph = () => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const [xValues, setXValues] = useState<any>([]);

  const formatDate = (date: any) => {
    if (xValues.includes(date.getMonth())) {
      setXValues([...xValues, date.getMonth()]);
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("MMMM");
    }
    return moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM");
  };

  return (
    <View style={{ width: "100%", height: "70%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          width={730}
          height={250}
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            tickFormatter={(date) => formatDate(new Date(date))}
            tick={{ fill: textw, fontSize: 13 }}
          />
          <YAxis tick={{ fill: textw, fontSize: 13 }} />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip
            cursor={{
              stroke: COLORS.lightGray4,
              strokeWidth: 2,
              strokeDasharray: 2,
            }}
            separator={" "}
            itemStyle={{}}
            wrapperStyle={{}}
            contentStyle={{}}
            labelStyle={{}}
            label={"Hello world"}
            content={<ChartTooltip />}
            // content is custom tooltip can delete to change default
          />
          <Area
            type="monotone"
            dataKey="uv"
            stroke="#8884d8"
            fillOpacity={1}
            fill="url(#colorUv)"
          />
          <Area
            type="monotone"
            dataKey="pv"
            stroke="#82ca9d"
            fillOpacity={1}
            fill="url(#colorPv)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </View>
  );
};

export default React.memo(CryptoTradingGraph);
// const res = Array(25).fill(0).map(Math.random);
